export default "__VITE_ASSET__95ce0fc7__"